import * as React from 'react';
import { Switch, Route, useRouteMatch, Redirect, useLocation } from 'react-router-dom';
import { ActionContext } from '../../context/ActionContext';
import { CmicContext } from '../../context/CmicContext';
import { ACTION_ROLE, ACTION_TYPE, ATTACHMENT_ACTION_ICONS } from '../../shared/Constants';
import Actions from './Actions';
import ProjListAction from './ProjListAction';
import AttchDocuments from '../documents/AttchDocuments';

const ActionRoutes = ({ enableDropbox }) => {
	const { path } = useRouteMatch();
	const { pathname } = useLocation();

	const { setActionTypeData } = React.useContext(ActionContext);
	const { userInfo } = React.useContext(CmicContext);

	const { useEffect } = React;

	useEffect(() => {
		if (userInfo.actionRole === ACTION_ROLE.ECM) {
			setActionTypeData({
				type: ACTION_TYPE.IMAGING,
				label: ATTACHMENT_ACTION_ICONS.ecm.label,
				nodeType: ATTACHMENT_ACTION_ICONS.ecm.type,
			});
		} else {
			setActionTypeData({
				type: null,
				label: null,
				nodeType: null,
			});
		}
	}, [userInfo.actionRole]);

	useEffect(() => {
		enableDropbox();
	}, [pathname]);

	return (
		<Switch>
			<Route path={`${path}/actions/documents`} component={AttchDocuments} />
			<Route path={`${path}/actions/list`} component={ProjListAction} />
			<Route path={`${path}/actions`} component={Actions} />
			<Route exact path={path}>
				{userInfo.actionRole === ACTION_ROLE.ECM ? (
					<Redirect to={`${path}/actions/list`} />
				) : (
					<Redirect to={`${path}/actions`} />
				)}
			</Route>
		</Switch>
	);
};

export default ActionRoutes;
